export enum DropdownLocation {
  CPT = "cpt",
  BUSINESS_OFFICE = "business_office",
  BOTH = "both",
  NONE = "none",
}
